import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from "react-router-dom";
import { ButtonBase } from "../Pedidos/styles";
import FaturamentoCard from "./FaturamentoCard";
import IntegracaoCard from "./IntegracaoCard";

const FaturamentoIntegracao = () => {
    const navigate = useNavigate();

    return (
      <Box sx={{ backgroundColor: 'ghostwhite', height: '100vh', paddingTop: '1.25rem' }}>
        <Box sx={{ width: '96%', maxWidth: '75rem', margin: '1.25rem auto 2rem', backgroundColor: 'ghostwhite' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3, gap: 2 }}>
              <Box>
                  <Typography component="h1" variant="h5" sx={{ fontWeight: 600, color: '#132350' }}>
                      Faturamento &amp; Integração SISDM
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                      Gere o faturamento mensal e a integração de ordens de serviço no SISDM a partir de um único painel.
                  </Typography>
              </Box>

              <ButtonBase variant="text" onClick={() => navigate(-1)}>
                  <KeyboardBackspaceIcon fontSize="small" sx={{ mr: 0.5 }}/> 
                  Sair
              </ButtonBase>
          </Box>

          <Grid container spacing={3} alignItems="stretch">
              <Grid item xs={12} md={6}>
                  <FaturamentoCard />
              </Grid>
              <Grid item xs={12} md={6}>
                  <IntegracaoCard />
              </Grid>
          </Grid>
        </Box>
      </Box>
    );
};

export default FaturamentoIntegracao;
